import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import 'react-select/dist/react-select.css';
import Loader from 'react-loader-spinner';
import PDFDownloadLink from './PDFDownloadLink';
import {
  setSameDaysCount,
  setTemplateToMenuBlock,
  setMenuMenuGenerator,
  setMenuGeneratorTemplate,
} from '../../../actions/menu';
import { getUser, getMatchedUsers, selectUser, userToProps } from '../../../actions/users';
import { getCalculateCBGU } from '../../../actions/calculateCbgu';
import UserDetailBlock from '../UserDetailBlock/UserDetailBlock';
import GenerateOptions from './GenerateOptions';
import ExceptCategoryBlock from '../../Common/ExceptCategoryBlock';
import { getUserIdFromQueryParams } from '../../../utils/url-params';
import debounce from '../../../utils/debounce';
import FindTemplateContainer from '../../Common/FindTemplateContainer/FindTemplateContainer';
import {
  SET_SEARCH_TEMPLATE_NAME,
  SET_TEMPLATES_PAGINATION_PAGE,
} from '../../../constants/constants';
import Complex from '../Complex';
import { setExceptCategories, setDayTabSelect } from '../../../actions/setParams';
import {
  getFolders,
  toggleRecommendedTemplate,
  setChoosedTemplateTags,
} from '../../../actions/folders';
import {
  CATEGORY_INGREDIENTS,
  getDefaultMenu,
  DEFAULT_COMPLEX_TYPE,
} from '../../../constants/appConstants';
import { resetChoosedTemplate, getTemplateSuccess } from '../../../actions/template';
import GenerateButton from './GenerateButton';
import {
  toggleIsShowConfirmPublishComplex,
  generateMenu,
  saveMenu,
  getPDF,
  publishSelectedComplex,
  updateSelectedComplexType,
} from '../../../actions/menuActions';
import { sendFilters } from '../../../actions/sendFilters';
import {
  setMenuTemplateGenerator,
  changeTemplateMenuDays,
  selectTemplateTagsFilters,
  changeTemplateSameDaysCount,
  setChosenTemplateEatings,
} from '../../../actions/templateGenerator';
import { getTags } from '../../../actions/tags/getTags';
import ConfirmPopup from '../../Common/ConfirmPopup';
import BasketModal from '../../BasketModal';
import ControlBlock from '../../UsersSubnavigation/ControlBlock';

class DetailsForGenerate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUpdateComplexType: false,
      complexType: 0,
    };
  }

  componentDidMount() {
    const {
      getFolders,
      user,
      isShowRecommendedTemplate,
      selectedComplex,
      getTemplateSuccess,
      setChoosedTemplateTags,
      tags,
      getTags,
    } = this.props;
    getTemplateSuccess('');
    setChoosedTemplateTags([]);
    !tags.length && getTags();
    if (user.name && isShowRecommendedTemplate && selectedComplex) {
      getFolders(1, '', '', user.id, selectedComplex.period);
    } else {
      getFolders();
    }
  }

  toggleRecommendedTemplateCheckbox = () => {
    const {
      user,
      selectedComplex,
      toggleRecommendedTemplate,
      isShowRecommendedTemplate,
      getFolders,
    } = this.props;
    toggleRecommendedTemplate();
    if (isShowRecommendedTemplate) {
      getFolders();
    } else {
      let genderTag = '';
      if (user.params.gender.gender === 'Женский') {
        genderTag = [94];
      } else if (user.params.gender.gender === 'Мужской') {
        genderTag = [93];
      }
      getFolders(1, '', genderTag, user.id, selectedComplex.period);
    }
  };

  handleCheckTemplate = (template, tabSelected) => {
    const { setTemplateToMenuBlock } = this.props;
    setTemplateToMenuBlock(template.complex_menu_id, tabSelected);
  };

  handleUpdateUserValue = (value) => {
    const { getUser, resetChoosedTemplate } = this.props;
    resetChoosedTemplate();
    getUser(value);
  };

  handleUpdateText = (value) => {
    const {
      getMatchedUsers,
      user,
      isShowRecommendedTemplate,
      selectedComplex,
      getFolders,
    } = this.props;
    value.length > 1 && getMatchedUsers(value);
    if (user.name && isShowRecommendedTemplate && selectedComplex) {
      let genderTag = '';
      if (user.params.gender.gender === 'Женский') {
        genderTag = [94];
      } else if (user.params.gender.gender === 'Мужской') {
        genderTag = [93];
      }
      getFolders(1, '', genderTag, user.id, selectedComplex.period);
    } else {
      getFolders();
    }
  };

  handleMenuGenerateClick = () => {
    const {
      setDayTabSelect,
      sendFilters,
      generateMenu,
      category,
      selectedDayCount,
      sameDaysCount,
      chosenEatings,
      selectedComplex,
      user,
    } = this.props;
    setDayTabSelect(0);
    sendFilters(category);
    generateMenu(
      category,
      selectedDayCount,
      sameDaysCount,
      selectedComplex ? selectedComplex.id : '',
      chosenEatings,
      user,
    );
  };

  saveMenus = () => {
    const {
      menu,
      user,
      selectedDayCount,
      category,
      saveMenu,
      selectedComplex,
      chosenEatings,
    } = this.props;
    saveMenu(menu, user, selectedComplex.id, +selectedDayCount, category, chosenEatings);
  };

  handleGetPDFClick = () => {
    const { selectedComplex, getPDF } = this.props;
    if (selectedComplex && selectedComplex.foodCourse) {
      getPDF(selectedComplex.foodCourse);
    }
  };

  menuToTemplate = () => {
    const {
      setMenuTemplateGenerator,
      changeTemplateMenuDays,
      selectTemplateTagsFilters,
      changeTemplateSameDaysCount,
      setChosenTemplateEatings,
    } = this.props;
    const { menu, selectedComplex, category, sameDaysCount, chosenEatings } = this.props;
    setMenuTemplateGenerator(menu);
    changeTemplateMenuDays(selectedComplex && selectedComplex.period ? selectedComplex.period : 7);
    selectTemplateTagsFilters(category);
    changeTemplateSameDaysCount(sameDaysCount);
    setChosenTemplateEatings(chosenEatings);
  };

  handleMenuClearClick = () => {
    const { setMenuMenuGenerator } = this.props;
    setMenuMenuGenerator(getDefaultMenu());
    setMenuGeneratorTemplate(false);
  };

  onApplyPublishComplex = () => {
    const { publishSelectedComplex, selectedComplex } = this.props;
    publishSelectedComplex(selectedComplex.id);
  };

  complexTypeChange = (type) => {
    this.setState({ isUpdateComplexType: true });
    this.setState({ complexType: type });
  };

  onComplexChange = (type) => {
    this.setState({ complexType: type });
  };

  onUpdateComplexType = () => {
    const { selectedComplex, updateSelectedComplexType } = this.props;
    const { complexType } = this.state;
    this.setState({ isUpdateComplexType: false });
    updateSelectedComplexType(selectedComplex.id, complexType);
  };

  render() {
    const {
      users,
      selectedDate,
      templateName,
      location,
      user,
      tags,
      setExceptCategories,
      category,
      isUsersDataLoading,
      loader,
      allTemplates,
      template,
      searchNameTemplate,
      setSearchTemplateName,
      isLoadTemplates,
      errMessTemplates,
      pageCount,
      getFolders,
      setTemplatePaginationPage,
      selectedComplex,
      menu,
      PDFError,
      PDFUrl,
      isShowConfirmPublishComplex,
      toggleIsShowConfirmPublishComplex,
      isShowBasket,
      tabSelected,
    } = this.props;
    const { isUpdateComplexType, complexType } = this.state;
    const usersDataForSelect = users.map((user) => ({
      name: `${user.name} (${user.id})`,
      id: user.id,
    }));
    getUserIdFromQueryParams() && usersDataForSelect.push({ name: user.name, id: user.id });
    const isMenuBlockFill = JSON.stringify(menu) !== JSON.stringify(getDefaultMenu());
    const isDisabledGetPDFBtn =
      !isMenuBlockFill || loader || !selectedComplex || !selectedComplex.foodCourse;
    const isDisabledSaveBtn = !isMenuBlockFill || !user.id || !selectedComplex;
    const isDisabledTemplateBtn = !isMenuBlockFill;
    return (
      <DetailsForGenerateBlock>
        <ControlBlock title="Назначение курса" />
        <WrapGenerationOptions>
          <SelectContainer>
            <H1>Выберите пользователя</H1>
            <Select
              // eslint-disable-next-line react/no-string-refs
              ref="userSelect"
              options={usersDataForSelect}
              simpleValue
              clearable
              name="select-user"
              value={user.id}
              onChange={this.handleUpdateUserValue}
              onInputChange={debounce(this.handleUpdateText, 1000)}
              searchable
              labelKey="name"
              valueKey="id"
              placeholder="Выберите пользователя..."
              isLoading={isUsersDataLoading}
              disabled={loader}
            />
            <Complex complexTypeChange={this.onComplexChange} />
            {selectedComplex && (
              <React.Fragment>
                <H1>Укажите тип курса</H1>
                <WrapComplexElements>
                  <div style={{ width: '240px' }}>
                    <Select
                      defaultValue={complexType}
                      options={DEFAULT_COMPLEX_TYPE}
                      clearable={false}
                      value={complexType}
                      onChange={(e) => this.complexTypeChange(e.value)}
                      placeholder="Выберите тип курса..."
                      isLoading={isUsersDataLoading}
                      disabled={loader}
                    />
                  </div>
                  <Button
                    onClick={this.onUpdateComplexType}
                    primary
                    disabled={!isUpdateComplexType}
                  >
                    Сохранить тип комплекс курса
                  </Button>
                </WrapComplexElements>
              </React.Fragment>
            )}
            <UserDetailBlock userIndex={user.id} />
          </SelectContainer>
          <GenerateOptions
            date={selectedDate}
            userIndex={user.id}
            name={templateName}
            location={location}
          />
        </WrapGenerationOptions>
        {selectedComplex && (
          <React.Fragment>
            <TemplateSelectWrapper>
              <H1>Выберите шаблон</H1>
              <FindTemplateContainer
                handleCheckTemplate={this.handleCheckTemplate}
                tabSelected={tabSelected}
                allTemplates={allTemplates}
                pageCount={pageCount}
                isLoadTemplates={isLoadTemplates}
                errMessTemplates={errMessTemplates}
                template={template}
                searchNameTemplate={searchNameTemplate}
                getFolders={getFolders}
                setSearchTemplateName={setSearchTemplateName}
                setTemplatePaginationPage={setTemplatePaginationPage}
                toggleRecommendedTemplateCheckbox={this.toggleRecommendedTemplateCheckbox}
                isRecommended
                searchFieldWidth="56%"
                filterBlockWidth="80%"
                tags={tags}
              />
            </TemplateSelectWrapper>
          </React.Fragment>
        )}
        <GenerateButton
          handleMenuGenerateClick={this.handleMenuGenerateClick}
          user={user}
          loader={loader}
          saveMenus={this.saveMenus}
          isDisabledSaveBtn={isDisabledSaveBtn}
          handleGetPDFClick={this.handleGetPDFClick}
          isDisabledGetPDFBtn={isDisabledGetPDFBtn}
          menuToTemplate={this.menuToTemplate}
          isDisabledTemplateBtn={isDisabledTemplateBtn}
          handleMenuClearClick={this.handleMenuClearClick}
          selectedComplex={selectedComplex}
          toggleIsShowConfirmPublishComplex={toggleIsShowConfirmPublishComplex}
        />
        {loader && (
          <Spinner>
            <Loader type="Ball-Triangle" color="#3a3a3a" height="40" width="40" />
          </Spinner>
        )}
        <PDFDownloadLink PDFError={PDFError} PDFUrl={PDFUrl} />
        <ExceptCategoryBlock
          title="Выберите какие продукты вы хотите исключить:"
          tags={tags}
          category={category}
          setExceptCategories={setExceptCategories}
          categoryIngredients={CATEGORY_INGREDIENTS}
        />
        <ConfirmPopup
          title="Хотите опубликовать курс?"
          text="После публикации курса он будет доступен в приложении пользователю. Если дата начала комплекс курса не была задана, меню и тренировки будут доступны пользователю после выбора им даты старта курса или вами."
          isShow={isShowConfirmPublishComplex}
          onClose={toggleIsShowConfirmPublishComplex}
          onApply={this.onApplyPublishComplex}
        />
        {selectedComplex && selectedComplex.startDate && isShowBasket && (
          <BasketModal complex={selectedComplex} />
        )}
      </DetailsForGenerateBlock>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    users,
    userSuccess,
    selectedDate,
    isUsersDataLoading,
    user,
    PDFError,
    PDFUrl,
  } = state.reducers;
  const {
    selectedDayCount,
    sameDaysCount,
    chosenEatings,
    // template container properties
    menuAllTemplates,
    menuTemplate,
    menuTemplatesPageCount,
    menuTemplatesCurrentPage,
    menuSearchNameTemplate,
    menuIsLoadTemplates,
    menuErrMessTemplates,
    menu,
    isShowConfirmPublishComplex,
  } = state.menu;
  const {
    allTemplates,
    template,
    filterCategoryTemplates,
    searchNameTemplate,
    currentPage,
    isLoadTemplates,
    errMessTemplates,
  } = state.template;
  const { pageCount, isShowRecommendedTemplate } = state.folders;
  const { calloriesNorm, tabSelected } = state.setParams;
  const { cbgu } = state.calculateCbgu;
  const { category } = state.setParams;
  const { tags } = state.getTags;
  const { selectedComplex } = state.complex;
  const { loader } = state.loader;
  const { isShowBasket } = state.basket;
  const { templateTabSelected } = state.templateGenerator;

  return {
    users,
    isUsersDataLoading,
    loader,
    user,
    cbgu,
    calloriesNorm,
    selectedDayCount,
    tabSelected,
    userSuccess,
    selectedDate,
    category,
    tags,
    allTemplates,
    template,
    filterCategoryTemplates,
    searchNameTemplate,
    currentPage,
    isLoadTemplates,
    errMessTemplates,
    menuAllTemplates,
    menuTemplate,
    menuTemplatesPageCount,
    menuTemplatesCurrentPage,
    menuSearchNameTemplate,
    menuIsLoadTemplates,
    menuErrMessTemplates,
    pageCount,
    selectedComplex,
    isShowRecommendedTemplate,
    menu,
    sameDaysCount,
    chosenEatings,
    PDFError,
    PDFUrl,
    isShowConfirmPublishComplex,
    isShowBasket,
    templateTabSelected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    publishSelectedComplex: (complexId) => {
      dispatch(publishSelectedComplex(complexId));
    },
    getPDF: (id) => {
      dispatch(getPDF(id));
    },
    saveMenu: (menu, user, complexId, days, category, chosenEatings) => {
      dispatch(saveMenu(menu, user, complexId, days, category, chosenEatings));
    },
    getFolders: (pageNumber, name, tags, userId, selectedComplexPeriod) => {
      dispatch(getFolders(pageNumber, name, tags, userId, selectedComplexPeriod));
    },
    setSearchTemplateName: (name) => {
      dispatch({ type: SET_SEARCH_TEMPLATE_NAME, payload: { name } });
    },
    setTemplatePaginationPage: (numberPage) => {
      dispatch({ type: SET_TEMPLATES_PAGINATION_PAGE, payload: { numberPage } });
    },
    getUser: (userId) => {
      dispatch(getUser(userId));
    },
    getMatchedUsers: (usernameValue) => {
      dispatch(getMatchedUsers(usernameValue));
    },
    selectUser: (userId) => {
      dispatch(selectUser(userId));
    },
    getCalculateCBGU: (userData) => {
      dispatch(getCalculateCBGU(userData));
    },
    userToProps: (user) => {
      dispatch(userToProps(user));
    },
    setSameDaysCount: (data) => {
      dispatch(setSameDaysCount(data));
    },
    resetChoosedTemplate: () => {
      dispatch(resetChoosedTemplate());
    },
    setExceptCategories: (data) => {
      dispatch(setExceptCategories(data));
    },
    setTemplateToMenuBlock: (idTemplate, specificDay) => {
      // TODO: remove specificDay
      dispatch(setTemplateToMenuBlock(idTemplate, specificDay));
    },
    toggleRecommendedTemplate: () => {
      dispatch(toggleRecommendedTemplate());
    },
    toggleIsShowConfirmPublishComplex: () => {
      dispatch(toggleIsShowConfirmPublishComplex());
    },
    setDayTabSelect: (tabNumber) => {
      dispatch(setDayTabSelect(tabNumber));
    },
    sendFilters: (data) => {
      dispatch(sendFilters(data));
    },
    generateMenu: (category, days, duplicateDays, method, complex_id, chosenEatings) => {
      dispatch(generateMenu(category, days, duplicateDays, method, complex_id, chosenEatings));
    },
    setMenuTemplateGenerator: (menu) => {
      dispatch(setMenuTemplateGenerator(menu));
    },
    changeTemplateMenuDays: (countDays) => {
      dispatch(changeTemplateMenuDays(countDays));
    },
    selectTemplateTagsFilters: (templateTagsFilters) => {
      dispatch(selectTemplateTagsFilters(templateTagsFilters));
    },
    changeTemplateSameDaysCount: (sameDaysCount) => {
      dispatch(changeTemplateSameDaysCount(sameDaysCount));
    },
    setChosenTemplateEatings: (tagsIds) => {
      dispatch(setChosenTemplateEatings(tagsIds));
    },
    setMenuMenuGenerator: (menu) => {
      dispatch(setMenuMenuGenerator(menu));
    },
    setMenuGeneratorTemplate: (template) => {
      dispatch(setMenuGeneratorTemplate(template));
    },
    getTemplateSuccess: (template) => {
      dispatch(getTemplateSuccess(template));
    },
    setChoosedTemplateTags: (tags) => {
      dispatch(setChoosedTemplateTags(tags));
    },
    getTags: () => {
      dispatch(getTags());
    },
    updateSelectedComplexType: (complexId, complexType) => {
      dispatch(updateSelectedComplexType(complexId, complexType));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DetailsForGenerate));

const DetailsForGenerateBlock = styled.div`
  width: 80%;
  margin: 0 auto;
  @media (max-width: 675px) {
    width: 100%;
  }
  .react-calendar__tile--active:disabled {
    background-color: #006edc;
  }
`;

const SelectContainer = styled.div`
  display: inline-block;
  margin: 10px auto 0;
  height: auto;
  font-size: 18px;
  @media (max-width: 620px) {
    width: 100%;
  }
`;

const Spinner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 300px;
  margin: 20px auto;
  justify-content: center;
`;

const WrapGenerationOptions = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;

const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
`;

const TemplateSelectWrapper = styled.div`
  margin: 10px;
`;

const WrapComplexElements = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/DetailsForGenerateBlock/DetailsForGenerate.jsx